import { SHTableCell, SHTableCellProps, SHTypography } from "@components/design-systems";
import { useTheme } from "@mui/material";
import { hexToRGBA } from "@utils";

interface SummaryFeatureIncludedCellProps extends SHTableCellProps {
  children: React.ReactNode;
  isHeader?: boolean;
}
export const SummaryFeatureIncludedCell = ({ children, isHeader, ...others }: SummaryFeatureIncludedCellProps) => {
  const { palette } = useTheme();

  return (
    <SHTableCell
      sx={{
        height: "50px",
        borderLeft: `solid 1px ${
          isHeader ? palette.divider : hexToRGBA(palette.primary[50], 0.3)
        }`,
      }}
      {...others}
    >
      {isHeader ? (
        <SHTypography variant="subtitle1" fontWeight={700} lineHeight={"120%"}>
          {children}
        </SHTypography>
      ) : (
        children
      )}
    </SHTableCell>
  );
};
